import messages from "./messages";

export const defaultLocale = "en";
export const supportedLanguages = Object.keys(messages);

export const getInitialLocale = (): string => {
  const savedLocale = localStorage.getItem("language");
  const browserLanguage = navigator.language.split("-")[0];

  if (savedLocale && supportedLanguages.includes(savedLocale)) {
    return savedLocale;
  }

  return supportedLanguages.includes(browserLanguage)
    ? browserLanguage
    : defaultLocale;
};

export const getMessages = (locale: string) => {
  return messages[locale] || messages[defaultLocale];
};

export const isLocaleSupported = (locale: string): boolean =>
  supportedLanguages.includes(locale);
